import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Shop.css";

function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/products")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="page-container">
      <h1 className="page-title">Shop</h1>
      {loading && <div className="body-text">Loading...</div>}
      {!loading && products.length === 0 && <div className="body-text">Coming soon</div>}
      {!loading && products.length > 0 && (
        <div className="product-grid">
          {products.map((p) =>
            p.stock > 0 ? (
              <Link to={`/shop/${p.id}`} key={p.id} className="product-card-link">
                <div className="product-card">
                  <img src={p.image} alt={p.name} className="product-image" />
                  <div className="product-name">{p.name}</div>
                  <div className="product-price">{p.price}</div>
                </div>
              </Link>
            ) : (
              <div key={p.id} className="product-card-link">
                <div className="product-card product-card-disabled">
                  <img src={p.image} alt={p.name} className="product-image" />
                  <div className="product-name">{p.name}</div>
                  <div className="product-price">{p.price}</div>
                  <div className="out-of-stock-label">Out of stock</div>
                </div>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
}

export default Shop;